import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';
import AttestationTravailPDF from './AttestationTravailPDF';
import CertificatTravailPDF from './CertificatTravailPDF';
import DecisionPDF from './DecisionPDF';

const PDFModalReport = ({ reportData, onClose }) => {
  // Vérification de sécurité
  if (!reportData) {
    return (
      <Dialog open={true} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>Erreur</DialogTitle>
        <DialogContent>
          <Typography>Aucune donnée de rapport disponible</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  const renderPDF = () => {
    switch (reportData.type) {
      case 'attestation_travail':
        return <AttestationTravailPDF data={reportData} />;
      case 'certificat_travail':
        return <CertificatTravailPDF data={reportData} />;
      case 'decision':
        return <DecisionPDF data={reportData} />;
      default:
        return <div>Type de rapport non supporté</div>;
    }
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Voir PDF - {reportData.type_label}</DialogTitle>
      <DialogContent>
        <PDFViewer style={{ width: '100%', height: '600px' }}>
          {renderPDF()}
        </PDFViewer>
      </DialogContent>
    </Dialog>
  );
};

export default PDFModalReport;
